// extracted by mini-css-extract-plugin
export var cardHeader = "_ss-0";
export var reorderHandle = "_ss-3";
export var titleArea = "_ss-1";
export var titleAreaWithHandle = "_ss-2";